import Spinner from './Spinner';

interface Props {
  /** Visible caption, e.g. "Loading books…". */
  label: string;
  className?: string;
}

/** The one loading block for page-level and table-level fetches: a spinner with a caption. */
export default function LoadingState({ label, className = '' }: Props) {
  return (
    <div aria-busy="true" className={`flex flex-col items-center justify-center gap-2 py-10 text-sm text-muted ${className}`}>
      <Spinner size="md" />
      <span>{label}</span>
    </div>
  );
}
